/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Schedule_Day_TueInputs */



/**
* | output |
* | --- |
* | "Tuesday" |
*
* @param {Agent_Schedule_Day_TueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedule_day_tue = /** @type {((inputs?: Agent_Schedule_Day_TueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedule_Day_TueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dienstag")
	return /** @type {LocalizedString} */ ("Tuesday")
});